import axios from 'axios';

export default {
    FETCH_EXPERTS ({commit, dispatch}, payload){
      return new Promise((resolve, reject) => {
        commit('TOGGLE_LOADING', true);
        // axios.post('login/authenticate', payload)
        axios.get('experts')
          .then((response) => {
            const { data: { data } } = response;
            localStorage.setItem('experts', JSON.stringify(data));
            commit('SET_EXPERTS', data);
            commit('TOGGLE_LOADING', false);
            resolve(data);
          })
          .catch((error) => {
            console.log('action fetch error : ', error);
            reject(error);
            commit('TOGGLE_LOADING', false);
          });
      })
    },
    GETSELECTEDEXPERT ({ commit }, expertId) {
      commit('TOGGLE_LOADING', true);
      return axios.get(`/experts/${expertId}`).then((response) => {
        commit('TOGGLE_LOADING', false);
        const { data: { data } } = response;
        commit('SET_SELECTED_EXPERT', data && data[0])
      }, (err) => {
        commit('TOGGLE_LOADING', false);
        console.log('err ', err)
      })
    },
    DELETE_SELECTED_EXPERT ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            return axios.delete(`/experts/${payload.expertId}?isDelete=${payload.isDelete}`).then((response) => {
                commit('TOGGLE_LOADING', false);
                const { data: { data } } = response;
                console.log('DELETE_SELECTED_EXPERT response ', response);
                resolve(data);
            }, (error) => {
                commit('TOGGLE_LOADING', false);
                console.log('DELETE_SELECTED_EXPERT error ', error);
                reject(error);
            })
        })

    },
    CREATE_EXPERT ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);

            let formData = new FormData();
            payload.expert = JSON.stringify(payload.expert);
            formData.append("expert", payload.expert);
            formData.append("large_file", payload.large_image);
            formData.append("small_file", payload.small_image);
            //formData.append("file", payload.large_image);

            //return axios.post(`/experts`, payload).then((response) => {
            return axios.post(`/experts`, formData).then((response) => {
                commit('TOGGLE_LOADING', false);
                const { data: { data } } = response;
                console.log('CREATE_EXPERT response ', response);
                resolve(data);
            }, (error) => {
                commit('TOGGLE_LOADING', false);
                console.log('CREATE_EXPERT error ', error);
                reject(error);
            })
        })

    },
    UPDATE_EXPERT ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);

            let formData = new FormData();
            payload.expert = JSON.stringify(payload.expert);
            formData.append("expert", payload.expert);
            payload.large_image.length &&  formData.append("large_file", payload.large_image[0]);
            payload.small_image.length && formData.append("small_file", payload.small_image[0]);
            //payload.large_image.length && formData.append("file", payload.large_image[0]);

            //return axios.put(`/experts`, payload).then((response) => {
            return axios.put(`/experts`, formData).then((response) => {
                commit('TOGGLE_LOADING', false);
                const { data: { data } } = response;
                console.log('UPDATE_EXPERT response ', response);
                resolve(data);
            }, (error) => {
                commit('TOGGLE_LOADING', false);
                console.log('UPDATE_EXPERT error ', error);
                reject(error);
            })
        })

    },
    UPDATE_EXPERTS_ORDERING ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            return axios.put(`experts/updExpertDispOrder`, payload).then((response) => {
                commit('TOGGLE_LOADING', false);
                const { data: { data } } = response;
                console.log('UPDATE_EXPERT response ', response);
                resolve(data);
            }, (error) => {
                commit('TOGGLE_LOADING', false);
                console.log('UPDATE_EXPERT error ', error);
                reject(error);
            })
        })

    },
    FETCH_INTERESTS ({commit, dispatch}){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.get('interests')
                .then((response) => {
                    const { data: { data } } = response;
                    data.unshift({interest: "Select an option"});
                    commit('SET_INTERESTS', data);
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                    console.log('FETCH_INTERESTS action response : ', response);
                })
                .catch((error) => {
                    console.log('FETCH_INTERESTS action error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/experts/actions.js